import React, { useState } from "react";
import Select from "react-select";
import {
  leadStatusOptions,
  leadTypeOptions,
  searchOptions,
  sourceOptions,
} from "../../reactSelectRowData";
import { targetRoleStatusOptions } from "../../reactSelectRowData";
import { campaignTypeStatusOptions } from "../../reactSelectRowData";
import { Field, useField, useFormikContext } from "formik";
import { MyFormValues } from "./leadManagement";
import { DropdownOption } from "../../types/dropDownTypes";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { store } from "../../store/store";
import { getDispositionList } from "../../store/actions/tempActions";
import { useAppSelector } from "../../store/hooks";
import { SubDisposition } from "../../types/tempTypes";

export default function LeadManageFilters() {
  const { values, setFieldValue } = useFormikContext<MyFormValues>();

  const handleStatusChange = (name: string, option: DropdownOption) => {
    setFieldValue(`filter['${name}']`, option.value);
  };
  const datePickerChangeHandler = (date: any, name: string, formik: any) => {
    setFieldValue(`filter['${name}']`, new Date(date));
  };
  const dispositionList = useAppSelector(
    (state) => state?.temp.dispositionList
  );
  const [subDispositionList, setSubDispositionList] =
    useState<SubDisposition[]>();
  const [searchBy, setSearchBy] = useState<string>("");
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <label
        htmlFor="status"
        className="crm-input-label text-[1rem] font-[500]"
      >
        Date Range
      </label>
      <>
        {" "}
        <DatePicker
          slotProps={{
            textField: {
              size: "small",
              error: false,
            },
          }}
          className="w-[15%] bg-white"
          format="DD/MM/YYYY"
          onChange={(e) => datePickerChangeHandler(e, "fromDate", values)}
          value={moment(values.filter.fromDate)}
        />
        -
        <DatePicker
          slotProps={{
            textField: {
              size: "small",
              error: false,
            },
          }}
          className="w-[15%] bg-white"
          format="DD/MM/YYYY"
          onChange={(e) => datePickerChangeHandler(e, "toDate", values)}
          value={moment(values.filter.toDate)}
        />
      </>
      <br />

      <div className=" w-[100%] flex flex-wrap gap-8  items-center">
        {" "}
        <div className="w-[20%] ">
          <label
            htmlFor="status"
            className="crm-input-label text-[1rem] font-[500]"
          >
            Lead Status
          </label>
          <Select
            className=""
            isSearchable
            id="status"
            name="status"
            options={leadStatusOptions}
            placeholder="Select status"
            noOptionsMessage={() => "No matching record found"}
            onChange={(option: any) => handleStatusChange("status", option)}
            value={leadStatusOptions.filter(
              (option) => option.value === values.filter.status
            )}
          />
        </div>
        {/* <ErrorMessage component="div" name="status" className="input-error" /> */}
        <div className="w-[20%] ">
          <label
            htmlFor="status"
            className="crm-input-label text-[1rem] font-[500]"
          >
            Target Role
          </label>
          <Select
            isSearchable
            id="roles"
            name="roles"
            options={targetRoleStatusOptions}
            placeholder="Select Role"
            noOptionsMessage={() => "No matching record found"}
            onChange={(option: any) => {
              handleStatusChange("roles", option);
              store.dispatch(getDispositionList({ roles: option.value }));
            }}
          />
        </div>
        <div className="w-[20%] ">
          <label
            htmlFor="status"
            className="crm-input-label text-[1rem] font-[500]"
          >
            Source
          </label>
          <Select
            // className="w-[15%]"
            isSearchable
            id="source"
            name="source"
            options={sourceOptions}
            placeholder="Select Stage"
            onChange={(option: any) => handleStatusChange("source", option)}
            noOptionsMessage={() => "No matching record found"}
          />
        </div>
        <div className="w-[20%] ">
          <label
            htmlFor="status"
            className="crm-input-label text-[1rem] font-[500]"
          >
            Call Type
          </label>
          <Select
            // className="w-[15%]"
            isSearchable
            id="leadType"
            name="leadType"
            options={leadTypeOptions}
            placeholder="Select Type"
            noOptionsMessage={() => "No matching record found"}
            onChange={(option: any) => handleStatusChange("leadType", option)}
          />
        </div>
        {/* <label
          htmlFor="status"
          className="crm-input-label text-[1rem] font-[500]"
        >
          Campaign Type
        </label>
        <Select
          className="w-[15%] "
          isSearchable
          id="type"
          name="type"
          options={campaignTypeStatusOptions}
          placeholder="Select Type"
          noOptionsMessage={() => "No matching record found"}
          onChange={(option: any) => handleStatusChange("type", option)}
        /> */}
        <div className="w-[20%] ">
          <label
            htmlFor="status"
            className="crm-input-label text-[1rem] font-[500]"
          >
            Disposition
          </label>
          <Select
            isSearchable
            id="dispositionId"
            name="dispositionId"
            options={dispositionList.map((item) => ({
              value: item.dispositionId,
              label: item.name,
              ...item,
            }))}
            placeholder="Select Disposition"
            noOptionsMessage={() => "No matching record found"}
            onChange={(option: any) => {
              console.log(option);
              setSubDispositionList(option.subDisposition);
              handleStatusChange("subDispositionId", {
                value: null,
                ...option,
              });
              handleStatusChange("dispositionId", option);
            }}
          />
        </div>
        {subDispositionList && (
          <>
            <div className="w-[20%] ">
              <label
                htmlFor="status"
                className="crm-input-label text-[1rem] font-[500]"
              >
                Sub Disposition
              </label>
              <Select
                isSearchable
                id="subDispositionId"
                name="subDispositionId"
                options={subDispositionList.map((item) => ({
                  value: item.subDispositionId,
                  label: item.name,
                }))}
                placeholder="Select Sub Disposition"
                noOptionsMessage={() => "No matching record found"}
                onChange={(option: any) =>
                  handleStatusChange("subDispositionId", option)
                }
              />
            </div>{" "}
          </>
        )}
      </div>
      <label
        htmlFor="status"
        className="crm-input-label text-[1rem] font-[500]"
      >
        Search By
      </label>
      <Select
        className="w-[15%] "
        isSearchable
        id="type"
        name="type"
        options={searchOptions}
        placeholder="Search By"
        noOptionsMessage={() => "No matching record found"}
        onChange={(option: any) => {
          setFieldValue(searchBy, undefined);
          setSearchBy(option.value);
        }}
      />
      {searchBy && (
        <Field
          className="rounded p-1 pl-3 "
          id={searchBy}
          name={searchBy}
          onKeyUp={(data: any) => setFieldValue(searchBy, data.target.value)}
          // placeholder={searchBy}
        />
      )}
    </LocalizationProvider>
  );
}
